export interface SeekopTokenClaims {
  // Standard JWT claims
  iss: string;
  aud: string;
  sub: string;
  jti: string;
  iat: number;
  nbf: number;
  exp: number;
  // Seekop-specific claims
  poolName:         string;
  dealerId:         string;
  dealer:           string;
  brand:            string;
  brandId:          string;
  enablePreowned:   boolean;
  enableMultiBrand: boolean;
  eMail:            string;
  origin:           string;
}

function decodePayload<T>(token: string): T | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = atob(padded);

    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}

export function decodeJwtPayload(token: string): SeekopTokenClaims | null {
  return decodePayload<SeekopTokenClaims>(token);
}

export function getTokenExpirationMs(token: string): number | null {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return null;
  return payload.exp * 1000;
}

export function getMillisecondsUntilExpiry(token: string): number | null {
  const expirationMs = getTokenExpirationMs(token);
  if (expirationMs === null) return null;
  return expirationMs - Date.now();
}
